import {ControlledSwitch} from '@hm/fundamental'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {HierarchyLevel, HIERARCHY_LEVELS} from '../../types'

interface HierarchyLevelToggleProps {
  value: HierarchyLevel
  onChange: (value: HierarchyLevel) => void
}

export const HierarchyLevelToggle: React.FC<HierarchyLevelToggleProps> = ({value, onChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const options = useMemo(
    () =>
      HIERARCHY_LEVELS.map((level) => ({
        label: t(`comparativeAnalysis.hierarchyLevel.${level}`),
        value: level
      })),
    [t]
  )

  return (
    <ControlledSwitch
      name="hierarchy-level-toggle"
      value={value}
      options={options}
      onChange={(newValue) => onChange(newValue as HierarchyLevel)}
      data-cy="hierarchy-level-toggle"
    />
  )
}
